import React from "react";
import { useTranslation } from "react-i18next";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import Button from "shared/components/FormElements/Button";
// import Skeleton from "@mui/material/Skeleton";
import { formatDateWithTimezone } from "shared/utility/date";
import { SMS_STATUS_CODES } from "features/sms/constants";
// import Fade from "@mui/material/Fade";
import Skeleton from "components/ui/feedback/Skeleton";

const SmsRow = ({
  entity,
  currentSmses,
  timezone,
  onSendSMS,
  isSmsSending,
  isSmsesLoaded,
  isDriver = false,
  extraInfo = null,
  maxSmsLength = 1000,
}) => {
  const { t } = useTranslation();

  return (
    <TableRow
      key={entity.id}
      sx={{
        backgroundColor: "inherit",
        "&:nth-of-type(odd)": {
          backgroundColor: "#fafbfc",
        },
        "& td": {
          borderBottom: "1px solid #e8eaed",
          py: 2,
        },
      }}
    >
      <TableCell component="th" scope="row" sx={{ padding: "16px", verticalAlign: "top" }}>
        <div style={{ fontWeight: isDriver ? 600 : 400 }}>
          {entity.name} <br /> {entity.phonenumber}
        </div>
        {extraInfo && (
          <div style={{ marginTop: "4px", fontSize: "12px", color: "#666", fontStyle: "italic" }}>{extraInfo}</div>
        )}
      </TableCell>

      <TableCell component="th" scope="row" sx={{ padding: "16px", verticalAlign: "top" }}>
        {currentSmses.length > 0 ? (
          <div>
            {currentSmses.reverse().map((sms) => (
              <div
                key={sms.id}
                style={{
                  marginBottom: "12px",
                  padding: "12px",
                  border: "1px solid #ddd",
                  borderRadius: "8px",
                  backgroundColor: "#f9f9f9",
                  boxShadow: "0 1px 3px rgba(0, 0, 0, 0.05)",
                }}
              >
                <div style={{ marginBottom: "6px", whiteSpace: "pre-wrap" }}>{sms.text}</div>
                <div style={{ fontSize: "12px", color: "#888", textAlign: "right" }}>
                  <div>
                    {sms.status === SMS_STATUS_CODES.DELIVERED &&
                      sms.deliveredDate &&
                      formatDateWithTimezone(sms.deliveredDate, timezone)}
                    {sms.status === SMS_STATUS_CODES.QUEUED && (
                      <span style={{ color: "var(--color-button-primary-danger-hover-background)" }}>
                        {t("smsNotReachedYet")}
                      </span>
                    )}
                    {sms.status !== SMS_STATUS_CODES.QUEUED && sms.status !== SMS_STATUS_CODES.DELIVERED && (
                      <span style={{ color: "var(--color-button-primary-danger-hover-background)" }}>
                        {t("smsCouldNotBeSent")}
                      </span>
                    )}
                    {/* {!sms.status && (
                          <span style={{ color: "var(--color-button-primary-danger-hover-background)" }}>
                            {t("smsProcessing")}
                          </span>
                        )} */}
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div>
            {isSmsesLoaded ? <div>{t("noMessage")}</div> : <Skeleton lineCount={3} widthPattern={["40", "60", "50"]} />}
          </div>
        )}
      </TableCell>

      <TableCell scope="row" align="right" sx={{ padding: "16px", verticalAlign: "top" }}>
        <div style={{ display: "flex", flexDirection: "column", width: "100%", paddingRight: "16px" }}>
          <textarea
            placeholder={t("typeYourMessage")} // çeviri ekle
            style={{
              marginBottom: "12px",
              padding: "12px",
              border: "1px solid #ccc",
              borderRadius: "8px",
              fontSize: "14px",
              resize: "vertical",
              minHeight: "180px",
              boxShadow: "0 2px 5px rgba(0, 0, 0, 0.05)",
              outline: "none",
              transition: "border-color 0.2s ease-in-out",
            }}
            onFocus={(e) => (e.target.style.borderColor = "#3f51b5")}
            onBlur={(e) => (e.target.style.borderColor = "#ccc")}
            id={"text" + entity.id.toString().trim()}
            cols="30"
            rows="3"
            maxLength={maxSmsLength}
          ></textarea>
          {/* <div style={{ textAlign: "right", fontSize: "12px", color: "#888" }}>
            {document.getElementById("text" + entity.id)?.value.length || 0}/155
          </div> */}
          <div style={{ display: "flex", justifyContent: "flex-end" }}>
            <Button
              type="button"
              disabled={isSmsSending || !entity.phonenumber?.length}
              isLoadingFromLeft={isSmsSending}
              danger
              onClick={() => onSendSMS(entity.id.toString().trim(), false, isDriver)}
            >
              {isDriver ? t("sendSmsToDriver") : t("sendSMS")}
            </Button>
          </div>
        </div>
      </TableCell>
    </TableRow>
  );
};

export default SmsRow;
